import React from 'react';
import Footer from '../components/Footer';
import '../App.css';

const MaritimeSecurity = () => {
 return (
  <div>

   {/* Hero Section */}
   <section className="service-hero">
    <div className='service-cover-text-ship'>
     <h1>Maritime Security</h1>
     <p>Safeguarding Your Assets, Crew, and Trade Routes</p>
    </div>
   </section>

   {/* Introduction */}
   <section className="service-intro">
    <div className="content">
     <h2>Expert Maritime Risk Management and Protection</h2>
     <p>
      In an unpredictable global environment, securing your maritime operations is paramount. We offer comprehensive security solutions, including **Vessel Hardening**, **Anti-Piracy Planning**, and strict **ISPS Code Compliance** to ensure your crew and cargo remain safe across all high-risk areas.
     </p>
    </div>
   </section>

   {/* Security and Risk Assessment */}
   <section className="service-section">
    <div className="service-split">
     <div className="text">
      <h3>🛡️ Security & Risk Assessment</h3>
      <p>
       Our expert security team conducts thorough risk assessments to identify vulnerabilities and threats specific to your vessel, itinerary, and cargo. This proactive approach minimizes exposure and enhances operational resilience.
      </p>

      <h4>🚨 Key Security Services</h4>
      <ul>
       <li><strong>Threat Analysis:</strong> Up-to-the-minute intelligence on piracy, terrorism, and political risks.</li>
       <li><strong>Vessel Security Plans:</strong> Developing and implementing ship-specific security protocols.</li>
       <li><strong>Security Audits:</strong> Comprehensive internal audits to verify compliance and readiness.</li>
       <li><strong>Secure Communication:</strong> Establishing robust and encrypted communication channels.</li>
      </ul>

      <h4>🌐 Focus Areas for Security</h4>
      <ul>
       <li>Transits through **High-Risk Areas (HRAs)**.</li>
       <li>Port and anchorage security during loading/unloading.</li>
       <li>Cyber security threats to navigation and systems.</li>
      </ul>

      <h4>✅ Our Security Process</h4>
      <ul>
       <li>🕵️ <strong>Assessment:</strong> In-depth risk and vulnerability reports.</li>
       <li>📝 <strong>Planning:</strong> Customized Security Plans and SOPs.</li>
       <li>훈련 <strong>Training:</strong> Crew readiness and counter-threat drills.</li>
       <li>🚨 <strong>Response:</strong> 24/7 emergency response and intelligence support.</li>
      </ul>
     </div>
     <div className="image">
      <img src="/images/Maritime-Security-Risk-Assessment.webp" alt="Maritime Security Risk Assessment" />
     </div>
    </div>
   </section>

   {/* ISPS Code & Compliance */}
   <section className="service-section alt">
    <div className="service-split">
     <div className="image">
      <img src="/images/ISPS-Code.webp" alt="ISPS Code & Regulatory Compliance" />
     </div>
     <div className="text">
      <h3>📜 ISPS Code & Security Compliance</h3>
      <p>
       The International Ship and Port Facility Security (ISPS) Code is the global standard for maritime security. We ensure full adherence, minimizing the risk of vessel detention and maximizing global access.
      </p>

      <h4>🎯 Our Compliance Assurance</h4>
      <ul>
       <li>✅ **Ship Security Plan (SSP)** Development and Certification.</li>
       <li>✅ Appointment and Training of **Company Security Officers (CSO)**.</li>
       <li>✅ Coordination of regular drills and exercises (**Security Level 1, 2, 3**).</li>
      </ul>

      <h4>🌀 The Cost of Non-Compliance</h4>
      <ul>
       <li>Vessel detention and severe operational delays.</li>
       <li>Significant financial penalties and loss of reputation.</li>
       <li>Insurance voidance in the event of an incident.</li>
      </ul>

      <h4>🧑‍💼 Private Maritime Security Details (PMSC)</h4>
      <p>
       For voyages through high-risk waters, we deploy highly-trained, accredited **Private Maritime Security Details** (PMSCs) to provide a physical deterrent and immediate response capability.
      </p>
      <ul>
       <li>🔫 Vetting and deployment of licensed security officers.</li>
       <li>🛠️ Provision of non-lethal and defensive security equipment.</li>
       <li>🚢 Liaison with naval forces and industry watchkeepers.</li>
      </ul>
     </div>
    </div>
   </section>

   {/* Why Choose Us (Updated) */}
   <section className="why-us">
    <h2>Why Choose Us for Maritime Security?</h2>
    <div className="why-grid">
     <div className="why-card">
      <h4>🗺️ Global Risk Intelligence</h4>
      <p>We provide real-time updates on high-risk areas and emerging threats worldwide.</p>
     </div>
     <div className="why-card">
      <h4>🔒 Accredited PMSC Partners</h4>
      <p>Deployment of highly-vetted, licensed security details for high-risk transits.</p>
     </div>
     <div className="why-card">
      <h4>⚖️ Full ISPS & SOLAS Compliance</h4>
      <p>We handle all regulatory documentation, training, and drills to ensure compliance.</p>
     </div>
     <div className="why-card">
      <h4>🧑‍🤝‍🧑 Crew Security Training</h4>
      <p>Specialized training to empower your crew to effectively manage security protocols.</p>
     </div>
    </div>
   </section>

   {/* Call to Action */}
   <section className="service-cta">
    <h2>Secure Your Global Operations Today</h2>
    <p>Don't leave your vessel's security to chance. Partner with us for robust protection and peace of mind.</p>
    <a href="/contact" className="cta-button">Request a Security Consultation</a>
   </section>

   <Footer />
  </div>
 );
};

export default MaritimeSecurity;